import styles from './BrandPromise.module.scss';

export default function BrandPromise() {

    return (
        <div>
            <img className={styles.brandPromise}
                src="brandPromise.svg" 
                alt="Trusted Values Innovative Solutions Shared Growth" 
            />
        </div>
    );
}